// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var MM_wrk_editor = require("./MM_wrk_editor.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");

function verifyDisjoints(wrkSubs, disj) {
  var varToSubVars = Belt_HashMapInt.make(Belt_MapInt.size(wrkSubs.subs));
  var getSubVars = function ($$var) {
    var arr = Belt_HashMapInt.get(varToSubVars, $$var);
    if (arr !== undefined) {
      return arr;
    }
    var expr = Belt_MapInt.get(wrkSubs.subs, $$var);
    Belt_HashMapInt.set(varToSubVars, $$var, expr !== undefined ? expr.filter(function (s) {
                return s >= 0;
              }) : []);
    return Belt_Option.getExn(Belt_HashMapInt.get(varToSubVars, $$var));
  };
  MM_context.disjForEach(disj, (function (n, m) {
          if (Belt_Option.isNone(wrkSubs.err)) {
            getSubVars(n).forEach(function (nv) {
                  if (Belt_Option.isNone(wrkSubs.err)) {
                    getSubVars(m).forEach(function (mv) {
                          if (Belt_Option.isNone(wrkSubs.err)) {
                            if (nv === mv) {
                              wrkSubs.err = {
                                TAG: /* CommonVar */0,
                                var1: n,
                                var2: m,
                                commonVar: nv
                              };
                            }
                            if (Belt_Option.isNone(wrkSubs.err) && !MM_context.disjContains(disj, nv, mv)) {
                              return MM_context.disjAddPair(wrkSubs.newDisj, nv, mv);
                            } else {
                              return ;
                            }
                          }
                          
                        });
                    return ;
                  }
                  
                });
            return ;
          }
          
        }));
}

function applyWrkSubs(expr, wrkSubs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
          return ;
        }
        var expr = Belt_MapInt.get(wrkSubs.subs, s);
        if (expr !== undefined) {
          resultSize.contents = resultSize.contents + expr.length | 0;
          return ;
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Cannot find a substitution for " + String(s) + " in applyWrkSubs."
              },
              Error: new Error()
            };
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else {
      var subExpr = Belt_MapInt.getExn(wrkSubs.subs, s);
      var len = subExpr.length;
      Expln_utils_common.copySubArray(subExpr, 0, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function applySubstitutionForEditor(st, wrkSubs) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var st$1 = MM_wrk_editor.createNewDisj(st, wrkSubs.newDisj);
    var newrecord = Caml_obj.obj_dup(st$1);
    newrecord.stmts = st$1.stmts.map(function (stmt) {
          var expr = MM_context.ctxSymsToIntsExn(wrkCtx$1, MM_wrk_editor.contToArrStr(stmt.cont));
          var newExpr = applyWrkSubs(expr, wrkSubs);
          var newrecord = Caml_obj.obj_dup(stmt);
          newrecord.cont = MM_wrk_editor.strToCont(MM_context.ctxIntsToStrExn(wrkCtx$1, newExpr), Caml_option.some(st$1.preCtxColors), Caml_option.some(st$1.wrkCtxColors), undefined);
          return newrecord;
        });
    return newrecord;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot apply substitution without wrkCtx."
        },
        Error: new Error()
      };
}

function convertSubsToWrkSubs(subs, tmpFrame, ctx) {
  var frameVarToCtxVar = function (frameVar) {
    var ctxSym = Belt_Array.get(tmpFrame.frameVarToSymb, frameVar);
    if (ctxSym !== undefined) {
      return MM_context.ctxSymToIntExn(ctx, ctxSym);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot convert frameVar to ctxVar."
          },
          Error: new Error()
        };
  };
  var res = Belt_HashMapInt.fromArray(Belt_Array.range(0, tmpFrame.numOfVars - 1 | 0).map(function (v) {
            return [
                    frameVarToCtxVar(v),
                    MM_substitution.applySubs([v], subs, (function (param) {
                            throw {
                                  RE_EXN_ID: MM_parser.MmException,
                                  _1: {
                                    msg: "Work variables are not supported in convertSubsToWrkSubs()."
                                  },
                                  Error: new Error()
                                };
                          }))
                  ];
          }));
  var maxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  for(var v = 0; v <= maxVar; ++v){
    if (!Belt_HashMapInt.has(res, v)) {
      Belt_HashMapInt.set(res, v, [v]);
    }
    
  }
  return {
          newDisj: MM_context.disjMake(undefined),
          subs: Belt_MapInt.fromArray(Belt_HashMapInt.toArray(res)),
          err: undefined
        };
}

function findPossibleSubsByMatch(wrkCtx, parenCnt, frmExpr, expr) {
  var axLabel = Caml_array.get(MM_context.generateNewLabels(wrkCtx, "temp-ax-", 1, undefined, undefined, undefined), 0);
  var tmpFrame = MM_context.createFrame(wrkCtx, 0, false, axLabel, MM_context.ctxIntsToSymsExn(wrkCtx, frmExpr), undefined, undefined, true, true, undefined, undefined, undefined, undefined, undefined);
  var frm = MM_substitution.prepareFrmSubsDataForFrame(tmpFrame);
  var foundSubs = [];
  MM_substitution.iterateSubstitutions(tmpFrame.asrt, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, parenCnt, (function (subs) {
          var wrkSubs = convertSubsToWrkSubs(subs, tmpFrame, wrkCtx);
          foundSubs.push(wrkSubs);
          return /* Continue */0;
        }));
  return {
          TAG: /* Ok */0,
          _0: foundSubs
        };
}

function makeCannotBuildSyntaxTreeError(expr, msg, ctx) {
  return "Cannot build a syntax tree for the expression '" + MM_context.ctxIntsToStrExn(ctx, expr) + "': " + msg + "";
}

function buildSyntaxTreesOfSameType(wrkCtx, syntaxTypes, frms, frameRestrict, parenCnt, expr1, expr2) {
  var syntaxTrees = MM_wrk_editor.textToSyntaxTree(wrkCtx, [
        MM_context.ctxIntsToSymsExn(wrkCtx, expr1),
        MM_context.ctxIntsToSymsExn(wrkCtx, expr2)
      ], syntaxTypes, frms, frameRestrict, parenCnt, undefined, (function (param) {
          
        }));
  if (syntaxTrees.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: syntaxTrees._0
          };
  }
  var match = syntaxTrees._0;
  if (match.length !== 2) {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "MM_wrk_editor_substitution.res",
            216,
            4
          ],
          Error: new Error()
        };
  }
  var tree1 = match[0];
  var tree2 = match[1];
  if (tree1.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: makeCannotBuildSyntaxTreeError(expr1, tree1._0, wrkCtx)
          };
  }
  var tree1$1 = tree1._0;
  if (tree2.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: makeCannotBuildSyntaxTreeError(expr2, tree2._0, wrkCtx)
          };
  }
  var tree2$1 = tree2._0;
  if (tree1$1.typ === tree2$1.typ) {
    return {
            TAG: /* Ok */0,
            _0: [
              tree1$1,
              tree2$1
            ]
          };
  }
  var syntaxTreeWithMatchingType = MM_wrk_editor.textToSyntaxTree(wrkCtx, [MM_context.ctxIntsToSymsExn(wrkCtx, expr1)], [tree2$1.typ], frms, frameRestrict, parenCnt, undefined, (function (param) {
          
        }));
  if (syntaxTreeWithMatchingType.TAG === /* Ok */0) {
    var match$1 = syntaxTreeWithMatchingType._0;
    if (match$1.length === 1) {
      var tree1$2 = match$1[0];
      if (tree1$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: [
                  tree1$2._0,
                  tree2$1
                ]
              };
      }
      
    }
    
  }
  var syntaxTreeWithMatchingType$1 = MM_wrk_editor.textToSyntaxTree(wrkCtx, [MM_context.ctxIntsToSymsExn(wrkCtx, expr2)], [tree1$1.typ], frms, frameRestrict, parenCnt, undefined, (function (param) {
          
        }));
  if (syntaxTreeWithMatchingType$1.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: "Cannot prove the two expressions are of the same type."
          };
  }
  var match$2 = syntaxTreeWithMatchingType$1._0;
  if (match$2.length !== 1) {
    return {
            TAG: /* Error */1,
            _0: "Cannot prove the two expressions are of the same type."
          };
  }
  var tree2$2 = match$2[0];
  if (tree2$2.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: [
              tree1$1,
              tree2$2._0
            ]
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Cannot prove the two expressions are of the same type."
          };
  }
}

function removeTypePrefix(expr, allTypes) {
  if (expr.length > 0 && allTypes.includes(Caml_array.get(expr, 0))) {
    return expr.slice(1);
  } else {
    return expr;
  }
}

function findPossibleSubsByUnif(wrkCtx, allTypes, syntaxTypes, frms, frameRestrict, parenCnt, expr1, expr2, metavarPrefix) {
  var syntaxTrees = buildSyntaxTreesOfSameType(wrkCtx, syntaxTypes, frms, frameRestrict, parenCnt, removeTypePrefix(expr1, allTypes), removeTypePrefix(expr2, allTypes));
  if (syntaxTrees.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: syntaxTrees._0
          };
  }
  var match = syntaxTrees._0;
  var $$continue = {
    contents: true
  };
  var foundSubs = Belt_HashMapString.make(expr1.length + expr2.length | 0);
  MM_syntax_tree.unify(match[0], match[1], (function (__x) {
          return __x.startsWith(metavarPrefix);
        }), foundSubs, $$continue);
  if (!$$continue.contents) {
    return {
            TAG: /* Error */1,
            _0: "Cannot unify these expressions."
          };
  }
  var res = Belt_HashMapInt.fromArray(Belt_HashMapString.toArray(foundSubs).map(function (param) {
            return [
                    MM_context.ctxSymToIntExn(wrkCtx, param[0]),
                    MM_context.ctxSymsToIntsExn(wrkCtx, param[1])
                  ];
          }));
  var maxVar = MM_context.getNumOfVars(wrkCtx) - 1 | 0;
  for(var v = 0; v <= maxVar; ++v){
    if (!Belt_HashMapInt.has(res, v)) {
      Belt_HashMapInt.set(res, v, [v]);
    }
    
  }
  return {
          TAG: /* Ok */0,
          _0: [{
              newDisj: MM_context.disjMake(undefined),
              subs: Belt_MapInt.fromArray(Belt_HashMapInt.toArray(res)),
              err: undefined
            }]
        };
}

function findPossibleSubs(st, frmExpr, expr, useMatching) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var foundSubs = useMatching ? findPossibleSubsByMatch(wrkCtx$1, st.parenCnt, frmExpr, expr) : findPossibleSubsByUnif(wrkCtx$1, st.allTypes, st.syntaxTypes, st.frms, st.settings.allowedFrms.inSyntax, st.parenCnt, frmExpr, expr, st.settings.unifMetavarPrefix);
    if (foundSubs.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: foundSubs._0
            };
    }
    var foundSubs$1 = foundSubs._0;
    var disj = MM_context.getAllDisj(wrkCtx$1);
    foundSubs$1.forEach(function (wrkSubs) {
          verifyDisjoints(wrkSubs, disj);
          if (Belt_Option.isNone(wrkSubs.err)) {
            var parenCnt = st.parenCnt;
            var frms = st.frms;
            var frameRestrict = st.settings.allowedFrms.inSyntax;
            var varToExprArr = Belt_MapInt.toArray(wrkSubs.subs);
            var typesToProve = varToExprArr.map(function (param) {
                  return [MM_context.getTypeOfVarExn(wrkCtx$1, param[0])].concat(param[1]);
                });
            var proofTree = MM_provers.proveFloatings(wrkCtx$1, frms, frameRestrict, typesToProve, parenCnt);
            varToExprArr.forEach(function (param, i) {
                  if (!Belt_Option.isNone(wrkSubs.err)) {
                    return ;
                  }
                  var typeExpr = Caml_array.get(typesToProve, i);
                  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(MM_proof_tree.ptGetNode(proofTree, typeExpr)))) {
                    wrkSubs.err = {
                      TAG: /* TypeMismatch */1,
                      var: param[0],
                      subsExpr: param[1],
                      typeExpr: typeExpr
                    };
                    return ;
                  }
                  
                });
            return ;
          }
          
        });
    return {
            TAG: /* Ok */0,
            _0: foundSubs$1
          };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot search for substitutions without wrkCtx."
        },
        Error: new Error()
      };
}

exports.findPossibleSubs = findPossibleSubs;
exports.applySubstitutionForEditor = applySubstitutionForEditor;
/* MM_context Not a pure module */
